import { useContext, useEffect, useRef, useState } from 'react'
import { Check2Square, PersonCircle, PlusCircle, Square } from 'react-bootstrap-icons'
import Access from '../../../../libs/api/services/Access'
import Authentication from '../../../../libs/api/services/Authentication'
import Team from '../../../../libs/api/services/Team'
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider'
import UserSearchBar from '../../../search/UserSearchBar'
import { AccessList } from '../../patient/management/AccessModal'

export default function DataAccessManagement() {
  const [mode, setMode] = useState()
  const [rule, setRule] = useState({
    AccessRuleName: undefined,
    facility: { id: Authentication.getFacility() },
    accessRuleGrants: [],
    accessRuleConsent: [],
    accessRuleResources: []
  })
  return (
    <div className='d-flex flex-column h-100 m-3 flex-grow-1' style={{ overflow: 'hidden' }}>
      <h1 className='text-center'>Data Access Management Rules</h1>
      {
        {
          'Add Rule': <NewRule rule={rule} setRule={setRule} onCancel={() => setMode()} />,
        }[mode] || <RulesBreakDown
          onEdit={(r) => {
            setRule(r);
            setMode('Add Rule')
          }
          }
          onAdd={() => {
            setRule({
              AccessRuleName: undefined,
              facility: { id: Authentication.getFacility() },
              accessRuleGrants: [],
              accessRuleConsent: [],
              accessRuleResources: []
            }); setMode('Add Rule')
          }}
        />
      }

    </div>
  )
}

const RolesModal = () => {
  const { showError } = useContext(CommonFunctionsContext)
  const [roles, setRoles] = useState([])

  useEffect(() => {
    const load = async () =>
      setRoles(await Access.ListFacilityRoles().catch(showError))
    load()
  }, [showError])

  const handleCreate = async (event) => {
    event.preventDefault()
    const form = new FormData(event.currentTarget)
    const entries = Object.fromEntries(form)

    const res = await Access.CreateFacilityRoles({
      role: entries.role,
      preferedName: entries.role,
      roleRelationship: entries.roleRelationship,
      isAvailable: true,
      faciltySpecific: {
        id: Authentication.getFacility()
      },
    }).catch(showError)
    if (res)
      setRoles([...roles, res])
  }
  return (<div className='d-flex flex-column flex-grow-1 m-3'>
    <div className='flex-grow-1'>

      {roles && roles.map(role => <ManageRoleLine key={role.id} role={role} />)}
    </div>
    <form onSubmit={handleCreate}>
      <div className='d-flex'>
        <div className='flex-grow-1'>
          <input name='role' className='form-control' placeholder='New Role' />
        </div>
        <div className='flex-grow-1 d-flex'>
          <select name='roleRelationship' className='form-control' placeholder='Role Relationship'>
            <option></option>
            <option value='System'>System Wide</option>
            <option value='Clinical'>Clinical RelationShip</option>
            <option value='PatientOther'>Other Patient Relationship</option>
          </select>
        </div>
        <button type='submit' className='btn'>Create Role</button>
      </div>
    </form>
  </div>)
}

const ManageRoleLine = ({ role }) => {
  const formRef = useRef()
  const { showError } = useContext(CommonFunctionsContext)
  const UpdateRole = async (event) => {
    event.preventDefault()
    const form = new FormData(formRef.current)
    const entries = Object.fromEntries(form)
    await Access.UpdateFacilityRoles({
      id: parseInt(entries.id),
      role: entries.role,
      preferedName: entries.role,
      roleRelationship: entries.roleRelationship,
      isAvailable: true,
      faciltySpecific: {
        id: Authentication.getFacility()
      },
    }).catch(showError)

  }

  return <form ref={formRef} className='d-flex'>
    <input type='hidden' value={role.id} name={`id`} />
    <div className='flex-grow-1'>
      <input
        onBlur={UpdateRole}
        name='role'
        className='form-control' defaultValue={role.role} placeholder={`Role`} /></div>

    <div>
      <select name='roleRelationship'
        onChange={UpdateRole}
        className='form-control' placeholder='Role Relationship'>
        <option></option>
        <option selected={role.roleRelationship === 'System'} value='System'>System Wide</option>
        <option selected={role.roleRelationship === 'Clinical'} value='Clinical'>Clinical RelationShip</option>
        <option selected={role.roleRelationship === 'PatientOther'} value='PatientOther'>Other Patient Relationship</option>
      </select>
    </div>
  </form>
}

const RulesBreakDown = ({ onAdd, onEdit }) => {
  const { createModal, showConfirm } = useContext(CommonFunctionsContext)
  const [rules, setRules] = useState([])
  useEffect(() => {
    const loadRules = async () =>
      setRules(await Access.GetAccessRules())
    loadRules()
  }, [])

  const DeleteRule = (idx) => {
    showConfirm({
      onCancel: () => { },
      onConfirm: () => Access.DeleteAccessRules(rules[idx].id)
        .then(res => {
          var _rules = rules
          _rules.splice(idx, 1)
          setRules([..._rules])
        }),
      title: "Confirm Delete",
      heading: "Confirm Delete",
      children: "Are you sure you would like to delete this rule?",
    })
  }

  const handleManageRoles = () =>
    createModal(<RolesModal />, 'Manage Roles', <PersonCircle />)

  return (<>
    <div className='d-flex align-items-center justify-content-end'>
      {Authentication.isClaimValid("System Admin") && <button onClick={handleManageRoles} className='btn'><PersonCircle /> Manage Roles</button>}

      <button onClick={onAdd} className='btn'><PlusCircle /> Add Rule</button>
    </div>
    <input className='form-control' placeholder='Search Rule' />
    <div className='w-100' style={{ cursor: 'pointer', overflow: 'auto', height: '90%' }}>
      {rules.map((rule, idx) => <div key={rule.id} className='d-flex align-items-center'>
        <div onClick={() => onEdit(rule)} className='flex-grow-1'>{rule.accessRuleName}</div>
        <button onClick={() => DeleteRule(idx)} className='btn'>Delete</button>
      </div>)}
    </div>
  </>)
}

const NewRule = ({ onAdd, onCancel, rule, setRule }) => {
  const { showError } = useContext(CommonFunctionsContext)
  const ruleNameRef = useRef()

  const handleSave = async (rule) => {
    if (!rule.accessRuleName || rule.accessRuleName.trim() === "")
      return false
    var res = await Access.UpsertAccessRule(rule).catch(showError)
    setRule({ ...rule, id: res.id })
  }

  const ToggleGrant = (GrantType) => {
    const grant = rule.accessRuleGrants.find(g => g.grantType === GrantType)
    if (grant) {
      rule.accessRuleGrants.splice(rule.accessRuleGrants.indexOf(grant), 1)
    } else {
      rule.accessRuleGrants.push({
        grantType: GrantType
      })
    }
    return rule.accessRuleGrants
  }
  const ToggleUsers = (Users) => {
    const grant = rule.accessRuleGrants.find(g => g.grantType === 'Specific Users')
    grant.user = Users
    return {
      ...rule,
      accessRuleGrants: rule.accessRuleGrants
    }
  }
  const ToggleUserRoles = (UserRoles) => {
    const grant = rule.accessRuleGrants.find(g => g.grantType === 'Specific Role')
    grant.userRoles = UserRoles
    return {
      ...rule,
      accessRuleGrants: rule.accessRuleGrants
    }
  }
  return (<form
    onSubmit={e => {
      e.preventDefault()
      handleSave({ ...rule, accessRuleName: ruleNameRef.current.value })
    }}
    className='d-flex flex-column flex-grow-1' style={{ maxHeight: 'calc(100% - 72px)' }}>
    <div className='flex-grow-1' style={{ overflow: 'auto' }}>
      <div>
        <input ref={ruleNameRef} onBlur={e => handleSave({ ...rule, accessRuleName: e.target.value })} defaultValue={rule.accessRuleName} className='form-control' placeholder='Access Rule Name' />
      </div>
      {rule.accessRuleName &&
        <>
          <div>
            <label>Access Level</label>
            <select
              onChange={e => handleSave({ ...rule, accessLevel: e.target.value })}
              className='form-control'>
              <option selected={rule.accessLevel === 'SYSTEM'} value='SYSTEM'>System Access</option>
              <option selected={rule.accessLevel === 'SHARE'} value='SHARE'>Data Share Access</option>
            </select>
          </div>
          {
            rule.accessLevel === 'SHARE' &&
            <div>
              <label>Valid For Days</label>
              <input type='number'
                min={0}
                defaultValue={rule.validForDays}
                placeholder='14'
                onChange={e => handleSave({ ...rule, validForDays: e.target.value && e.target.value !== "" ? e.target.value : 14 })}
                className='form-control'
              />
            </div>
          }
          <div>
            <b>Grant Access to</b>
          </div>
          <SelectionLineItem
            checked={rule && rule.accessRuleGrants && rule.accessRuleGrants && rule.accessRuleGrants.find(g => g.grantType === 'Leading Clinician')}
            onToggle={e => handleSave({ ...rule, grants: ToggleGrant('Leading Clinician') })}
            name={'Leading Clinician'} />
          {rule && rule.accessRuleGrants && rule.accessRuleGrants && rule.accessRuleGrants.find(g => g.grantType === 'Leading Clinician') &&
            <div className='ms-2'>
              <LeadSelectionComponent rule={rule} onSave={handleSave} />
            </div>
          }
          <SelectionLineItem
            checked={rule && rule.accessRuleGrants && rule.accessRuleGrants && rule.accessRuleGrants.find(g => g.grantType === 'Clinical Team')}
            onToggle={e => handleSave({ ...rule, grants: ToggleGrant('Clinical Team') })}
            name={'Clinical Team'} />
          {rule && rule.accessRuleGrants && rule.accessRuleGrants && rule.accessRuleGrants.find(g => g.grantType === 'Clinical Team') &&
            <div className='ms-2'>
              {/* <pre>
                {JSON.stringify(rule, 2, '\t')}
              </pre> */}
              <TeamsSelectionComponent rule={rule} onSave={handleSave} />
              {/* <SelectionLineItem
                checked={rule && rule.grants && rule.grants['Clinical Team'] && rule.grants['Clinical Team']['TEAMS ARRAY']}
                onToggle={e => handleSave({ ...rule, grants: { ...rule.grants, 'Clinical Team': { 'TEAMS ARRAY': e } } })}
                name={'TEAMS ARRAY'} /> */}
              {rule && rule.grants && rule.grants['Clinical Team'] && rule.grants['Clinical Team']['TEAMS ARRAY'] &&
                <div className='ms-2'>
                  <SelectionLineItem
                    checked={rule && rule.grants && rule.grants['Clinical Team'] && rule.grants['Clinical Team']['TEAMS ARRAY'] && rule.grants['Clinical Team']['TEAMS ARRAY']['All Members']}
                    onToggle={e => handleSave({ ...rule, grants: { ...rule.grants, 'Clinical Team': { 'TEAMS ARRAY': { 'All Members': e } } } })}
                    name={'All Members'} />
                  <SelectionLineItem
                    checked={rule && rule.grants && rule.grants['Clinical Team'] && rule.grants['Clinical Team']['TEAMS ARRAY'] && rule.grants['Clinical Team']['TEAMS ARRAY']['Specific Roles']}
                    onToggle={e => handleSave({ ...rule, grants: { ...rule.grants, 'Clinical Team': { 'TEAMS ARRAY': { 'Specific Roles': e } } } })}
                    name={'Specific Roles'} />
                  {rule && rule.grants && rule.grants['Clinical Team'] && rule.grants['Clinical Team']['TEAMS ARRAY'] && rule.grants['Clinical Team']['TEAMS ARRAY']['Specific Roles'] &&
                    <div className='ms-2'>
                      <RolesSelection
                        checked={rule && rule.grants && rule.grants['Clinical Team'] && rule.grants['Clinical Team']['TEAMS ARRAY'] && rule.grants['Clinical Team']['TEAMS ARRAY']['Specific Roles']}
                        onToggle={e =>
                          handleSave({ ...rule, grants: { ...rule.grants, 'Clinical Team': { 'TEAMS ARRAY': { 'Specific Roles': e } } } })
                        }
                      />
                    </div>
                  }
                </div>
              }
            </div>
          }
          <SelectionLineItem
            checked={rule && rule.accessRuleGrants && rule.accessRuleGrants && rule.accessRuleGrants.find(g => g.grantType === 'Specific Role')}
            onToggle={e => handleSave({ ...rule, grants: ToggleGrant('Specific Role') })}
            name={'Specific Role'} />
          {rule && rule.accessRuleGrants && rule.accessRuleGrants && rule.accessRuleGrants.find(g => g.grantType === 'Specific Role') &&
            <div className='ms-2'>
              <RolesSelection
                checked={rule && rule.accessRuleGrants &&
                  rule.accessRuleGrants.find(g => g.grantType === 'Specific Role').userRoles}
                onToggle={e => handleSave(ToggleUserRoles(e))} />
            </div>
          }
          <SelectionLineItem
            checked={rule && rule.accessRuleGrants && rule.accessRuleGrants && rule.accessRuleGrants.find(g => g.grantType === 'Specific Users')}
            onToggle={e => handleSave({ ...rule, grants: ToggleGrant('Specific Users') })}
            name={'Specific Users'} />
          {/* {JSON.stringify(rule.accessRuleGrants.find(g => g.grantType === 'Specific Users').user)} */}
          {rule && rule.accessRuleGrants && rule.accessRuleGrants && rule.accessRuleGrants.find(g => g.grantType === 'Specific Users') &&
            <UserSelectionLineItem
              checked={rule && rule.accessRuleGrants &&
                rule.accessRuleGrants.find(g => g.grantType === 'Specific Users').user}
              onToggle={e => handleSave(ToggleUsers(e))} />
          }
          <div>
            <b>Consent</b>
          </div>
          <SelectionLineItem
            checked={rule && rule.accessRuleConsent && rule.accessRuleConsent.length > 0}
            // onToggle={e => handleSave({ ...rule, consent: e })}
            name={'Requires consent'} />
          {rule.accessRuleConsent &&
            <ConsentSelection
              checked={rule && rule.accessRuleConsent}
              onToggle={e => {
                handleSave({ ...rule, accessRuleConsent: e })
              }
              }
            />
          }
          <div>
            <b>Has Access to</b>
          </div>
          <AccessList
            accessLevel={rule.accessLevel || 'SYSTEM'}
            allocatedResources={rule.accessRuleResources}
            setAllocatedResources={resources => handleSave({
              ...rule,
              accessRuleResources: resources
            })} />
          {/* <AccessLineItem
            checked={rule && rule.access && rule.access['Patient Profile']}
            onToggle={e => handleSave({ ...rule, access: { 'Patient Profile': e } })}
            name={'Patient Profile information'} /> */}
        </>
      }
    </div>
    <div className='text-center flex-shrink-1'>
      <button type='button' onClick={() => !rule.accessRuleName || rule.accessRuleName === "" ? onCancel() : handleSave(rule).then(_ => onCancel())} className='btn bg-primary-container'>Done</button>
    </div>

  </form>)
}

const LeadSelectionComponent = ({ rule, onSave }) => {
  const [teams, setTeams] = useState([])

  useState(() => {
    const load = async () => setTeams(await Team.GetFacilitiesTeams())
    load()
  }, [])

  const ToggleTeamGrant = (aTeam) => {
    // const grant = rule.accessRuleGrants.find(g => g.grantType === GrantType)
    // if (grant) {
    //   rule.accessRuleGrants.splice(rule.accessRuleGrants.indexOf(grant), 1)
    // } else {
    //   rule.accessRuleGrants.push({
    //     grantType: GrantType
    //   })
    // }
    const grant = rule.accessRuleGrants.find(g => g.team && g.team.id === aTeam.id)
    if (grant) {
      rule.accessRuleGrants.splice(rule.accessRuleGrants.indexOf(grant), 1)
    } else {
      rule.accessRuleGrants.push({
        grantType: 'Leading Clinician',
        team: aTeam
      })
    }
    return {
      ...rule,
      accessRuleGrants: [...rule.accessRuleGrants]
    }
  }


  return (
    teams && teams.map(aTeam =>
      <SelectionLineItem
        checked={rule && rule.accessRuleGrants && rule.accessRuleGrants.find(g => g.team && g.team.id === aTeam.id)}
        onToggle={e => onSave(ToggleTeamGrant(aTeam))}
        name={aTeam.teamName} />
    )
  )
}
const TeamsSelectionComponent = ({ rule, onSave }) => {
  const [teams, setTeams] = useState([])

  useState(() => {
    const load = async () => setTeams(await Team.GetFacilitiesTeams())
    load()
  }, [])

  const ToggleTeamGrant = (aTeam) => {
    // const grant = rule.accessRuleGrants.find(g => g.grantType === GrantType)
    // if (grant) {
    //   rule.accessRuleGrants.splice(rule.accessRuleGrants.indexOf(grant), 1)
    // } else {
    //   rule.accessRuleGrants.push({
    //     grantType: GrantType
    //   })
    // }
    const grant = rule.accessRuleGrants.find(g => g.team && g.team.id === aTeam.id)
    if (grant) {
      rule.accessRuleGrants.splice(rule.accessRuleGrants.indexOf(grant), 1)
    } else {
      rule.accessRuleGrants.push({
        grantType: 'Clinical Team',
        team: aTeam
      })
    }
    return {
      ...rule,
      accessRuleGrants: [...rule.accessRuleGrants]
    }
  }


  return (
    teams && teams.map(aTeam =>
      <SelectionLineItem
        checked={rule && rule.accessRuleGrants && rule.accessRuleGrants.find(g => g.team && g.team.id === aTeam.id)}
        onToggle={e => onSave(ToggleTeamGrant(aTeam))}
        name={aTeam.teamName} />
    )
  )
}

const UserSelectionLineItem = ({ checked, onToggle }) => {
  const handleRemove = (user) => {
    let _checked = Array.isArray(checked) ? checked : []
    if (_checked.findIndex(u => u.id === user.id) > -1)
      _checked.splice(_checked.findIndex(u => u.id === user.id), 1)
    onToggle(_checked)
  }
  const handleToggle = (user) => {
    let _checked = Array.isArray(checked) ? checked : []
    if (_checked.findIndex(u => u.id === user.id) > -1)
      _checked.splice(_checked.findIndex(u => u.id === user.id), 1)
    else
      _checked.push({
        user: user
      })
    onToggle(_checked)
  }
  return (<div>
    {Array.isArray(checked) && checked.map(user =>
      <div onClick={e => handleRemove(user)}>{user.user.firstName} {user.user.lastName} {user.user.idNumber}</div>
    )}
    <UserSearchBar facility={Authentication.getFacility()} noAdd showFull onUserSelected={handleToggle} fullProfile />
  </div>)
}

const SelectionLineItem = ({ name, checked, onToggle }) => {
  return (
    <div
      onClick={() => onToggle(!checked)}
      className={`d-flex ${checked && 'bg-primary-container'}`}>
      <div className='flex-grow-1'>{name}</div>
      <div>
        {checked ? <Check2Square size={'20'} /> : <Square size={'20'} />}
      </div>
    </div>)
}

const RolesSelection = ({ checked, onToggle }) => {
  const [Roles, setRoles] = useState([])
  // const Roles = ['Leading Clinician', 'Father', 'Patient', 'Nurse']

  useEffect(() => {
    const load = async () => setRoles(await Access.ListFacilityRoles())
    load()
  }, [])

  const handleToggle = (role, isChecked) => {
    let _checked = Array.isArray(checked) ? checked : []

    if (_checked.findIndex(u => u.userRole.id === role.id) > -1)
      _checked.splice(_checked.findIndex(u => u.id === role.id), 1)
    else
      _checked.push({
        userRole: role
      })
    onToggle(_checked)
  }

  return Roles.map(role => <SelectionLineItem
    // checked={Array.isArray(checked) && checked.includes(role.id)}
    checked={checked && checked.find(a => a.userRole.id === role.id)}
    onToggle={e => handleToggle(role, e)}
    key={role.id}
    name={role.role} />
  )
}

const ConsentSelection = ({ checked, onToggle }) => {
  //ConsentFrom
  const [Roles, setRoles] = useState([])
  // const Roles = ['Leading Clinician', 'Father', 'Patient', 'Nurse']

  useEffect(() => {
    const load = async () => setRoles(await Access.ListFacilityRoles())
    load()
  }, [])
  const handleToggle = (role, value) => {
    let _checked = typeof checked === 'object' ? checked : []

    const exists = _checked && _checked.find(c => c.consentFrom && c.consentFrom.role && c.consentFrom.role.id === role.id);
    if (exists) {
      if (value === '')
        _checked.splice(_checked.indexOf(exists), 1)
      else
        exists.consentAction = value
    }
    else
      _checked.push({
        consentFrom: { role: role },
        consentAction: value
      })
    onToggle(_checked)
  }
  return Roles.map(role => <div key={role.id} className='d-flex'>
    <div className='w-75'>{role.role}</div>
    <select onChange={e => handleToggle(role, e.target.value)} className='form-control form-control-sm'>
      <option value={undefined}></option>
      <option selected={checked && checked.find(a => a.consentFrom && a.consentFrom.role && a.consentFrom.role.id === role.id && a.consentAction === 'REQUIRED')} value='REQUIRED'>Needs to consent</option>
      <option selected={checked && checked.find(a => a.consentFrom && a.consentFrom.role && a.consentFrom.role.id === role.id && a.consentAction === 'NOTICE')} value='NOTICE'>Will be notified when information is requested</option>
      <option selected={checked && checked.find(a => a.consentFrom && a.consentFrom.role && a.consentFrom.role.id === role.id && a.consentAction === 'OVERRIDE')} value='OVERRIDE'>Can override consent</option>
    </select>
  </div>)
}